/**
 * 当前页的小节登记（规格 §4.3 / §5.3）。
 *
 * 两类小节：
 *   anchor —— 同一页纵向排布的区块，点击滚动定位，当前项由滚动决定；
 *   view   —— 互斥视图（原来的 Tab），点击改 URL 的 ?v=，当前项由 URL 决定。
 * 目录轨把两类都画成当前页下方的短横线。
 */
import { create } from 'zustand';

export type SectionKind = 'anchor' | 'view';

export interface SectionMeta {
  id: string;
  title: string;
  kind: SectionKind;
}

interface SectionState {
  sections: SectionMeta[];
  active: string | null;
  register: (s: SectionMeta) => void;
  unregister: (id: string) => void;
  setActive: (id: string | null) => void;
}

export const useSectionStore = create<SectionState>((set) => ({
  sections: [],
  active: null,
  register: (s) =>
    set((st) => {
      const i = st.sections.findIndex((x) => x.id === s.id);
      if (i === -1) return { sections: [...st.sections, s] };
      const cur = st.sections[i];
      if (cur.title === s.title && cur.kind === s.kind) return st;
      const next = st.sections.slice();
      next[i] = s;
      return { sections: next };
    }),
  unregister: (id) =>
    set((st) => ({
      sections: st.sections.filter((x) => x.id !== id),
      active: st.active === id ? null : st.active,
    })),
  setActive: (active) => set((st) => (st.active === active ? st : { active })),
}));
